<div class="input-field-container">
  <label class="input-label" *ngIf="label">
    {{ label }}<span class="required-asterisk" *ngIf="required">*</span>
  </label>
  <input 
    class="input-field"
    [class.error]="hasError"
    [type]="type"
    [placeholder]="placeholder"
    [value]="value"
    [disabled]="disabled"
    [attr.maxlength]="maxLength > 0 ? maxLength : null"
    (input)="onInput($event)"
    (blur)="onBlur()"
  />
  <div class="error-message" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div>
